import React from "react";
import { Component } from "react";

import { Container, Card } from "react-bootstrap";

class Footer extends Component {
    render() {
        return (
        <div>
            <Container>
    <Card>
        <Card.Body>
       
        <Card.Title><h3>Synthetic Visibility</h3></Card.Title>
 
            <Card.Text>

<p>Concept and programming by <a target="_blank" rel="noreferrer" href="https://marlonbarrios.github.io/">Marlon Barrios Solano</a></p>
<p><a target="_blank" rel="noreferrer" href="https://www.patreon.com/user?u=84024387">Support R&D and help with the costs of OpenAI</a></p>
<p>Powered by <a target="_blank" rel="noreferrer" href=" https://beta.openai.com/overview">OpenAI</a></p>
<p>Inspired by the ongoing work, practices and research of artists, curators and rule breakers; may this project honor you...</p>
            </Card.Text>
        </Card.Body>
    </Card>
</Container>
        </div>
        );
    }
    }
export default Footer;

